import { connect } from "react-redux";
import { PLANNING_SELECT_PDC_ID } from "../../../redux/types";
import EventForm from "./../../../components/planning/EventForm";
import {
  isLoading,
  deleteEvent,
  updatePlanningFilters,
  setKeyFilterSelected,
  sendNewEvent,
  sendUpdatedEvent,
  setKeyPdcFilterSelected,
  setKeySectorFilterSelected,
  getAvailableDateRange
} from "./../../../redux/actions/planningActions";
const clientWithVisitPreparation = [{ clientId: 11 }, { clientId: 111 }];

const mapStateToProps = (state, ownProps) => {
  return {
    isToBeModified: ownProps.isToBeModified,
    hasVisitPreparation:
      ownProps.isToBeModified &&
      clientWithVisitPreparation.filter(client => client.clientId === state.currentClient.id).length > 0,
    eventTypes: state.planning.eventTypes,
    availableDates: state.planning.availableDates,
    currentClient: state.currentClient,
    selectedType: ownProps.updateEventFromCalendarClick
      ? ownProps.eventInfos.event_type_label
      : state.planning.selectedType,
    selectedEmail: ownProps.updateEventFromCalendarClick
      ? ownProps.eventInfos.user_email
      : state.planning.selectedEmail,
    selectedSector: ownProps.updateEventFromCalendarClick
      ? ownProps.eventInfos.sector_label
      : state.planning.selectedSector,
    selectedPdc: ownProps.updateEventFromCalendarClick ? ownProps.eventInfos.pdc_label : state.planning.selectedPdc,
    selectedPdcId: ownProps.updateEventFromCalendarClick ? ownProps.eventInfos.pdc_id : state.planning.selectedPdcId,
    selectedEvent: state.planning.selectedEvent,
    modalIsLoading: state.planning.modalIsLoading,
    rdv: ownProps.eventInfos ? ownProps.eventInfos.rdv : null,
    visitType: ownProps.updateEventFromCalendarClick ? ownProps.eventInfos.visitType : state.planning.selectedTypeVisit,
    userPdcsListLabel:
      state.planning.filters && state.planning.filters.pdc_label ? state.planning.filters.pdc_label : [],
    userPdcs: state.planning.userPdcs || [],
    userSectorsList:
      state.planning.filters && state.planning.filters.sector_label ? state.planning.filters.sector_label : [],
    usersList: state.planning.filters && state.planning.filters.email ? state.planning.filters.email : [],
    typesVisitList: state.planning.typesVisit,
    requestResponse: state.planning.requestResponse
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    isLoading: value => dispatch(isLoading(value)),
    updateFilters: (key, value) => dispatch(updatePlanningFilters(key, value)),
    setKeyFilterSelected: key => dispatch(setKeyFilterSelected(key)),
    deleteEvent: event => dispatch(deleteEvent(event)),
    sendNewEvent: event => dispatch(sendNewEvent(event)),
    sendUpdatedEvent: (event, updateMethod) => dispatch(sendUpdatedEvent(event, updateMethod)),
    setKeyPdcFilterSelected: date => dispatch(setKeyPdcFilterSelected(date)),
    setKeySectorFilterSelected: date => dispatch(setKeySectorFilterSelected(date)),
    getAvailableDateRange: () => dispatch(getAvailableDateRange()),
    setSelectedPdcId: pdcId => dispatch({ type: PLANNING_SELECT_PDC_ID, payload: pdcId })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventForm);



// WEBPACK FOOTER //
// src/containers/activite/planning/EventFormContainer.js